import { render } from "./WaybillsPage.vue?vue&type=template&id=0a8c0581"
import script from "./WaybillsPage.vue?vue&type=script&lang=js"
export * from "./WaybillsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__